<template>
  <div>
    <upload @success='uploadImg' v-bind='UploadProperty' ref="child" :more='true'></upload>

    <div class="row-no-full" style="flex-wrap: wrap;">
      <div v-for="(v,i) in list" style="margin-right: 10px;margin-bottom: 10px;position: relative;" @mouseenter='enter(i)' @mouseleave="leave(i)" @click="del_img(i)">

        <div v-if="i==del_index" style="position: absolute;top: -5px;right: 0;z-index: 1;">
          <svg t="1600917546812" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="1393" width="20" height="20">
            <path d="M728.32 62.0032a38.4 38.4 0 1 0-33.28 69.2224A424.96 424.96 0 0 1 934.4 512c0 232.9088-189.4912 422.4-422.4 422.4S89.6 744.9088 89.6 512 279.0912 89.6 512 89.6a38.4 38.4 0 0 0 0-76.8C236.7488 12.8 12.8 236.7488 12.8 512s223.9488 499.2 499.2 499.2 499.2-223.9488 499.2-499.2a502.1184 502.1184 0 0 0-282.88-449.9968z"
              fill="#d81e06" p-id="1394"></path>
            <path d="M731.4432 331.008a38.4 38.4 0 0 0-65.5872-27.136L512 457.728 358.144 303.8208a38.4 38.4 0 0 0-54.3232 54.272L457.728 512l-153.856 153.856a38.2976 38.2976 0 0 0 27.136 65.536 38.0928 38.0928 0 0 0 27.136-11.264L512 566.3232l153.856 153.856a38.2976 38.2976 0 0 0 65.536-27.136 38.0928 38.0928 0 0 0-11.264-27.136L566.3232 512l153.856-153.856a38.0928 38.0928 0 0 0 11.264-27.136z"
              fill="#d81e06" p-id="1395"></path>
          </svg>
        </div>
        <el-image :src='getImgPrefix()+v'></el-image>
      </div>
    </div>

  </div>
</template>

<script>
  import Upload from './Upload.vue'
  export default {
    name: "ImgList",
    data() {
      return {

        del_index:-1

      }
    },
    methods: {

      uploadImg(img) {


        let temp = this.cloneObj(this.list);

        for (let i in img) {

          temp.push(img[i]);

        }

        this.$emit('update:list', temp);




      },
      enter(i) {

        // console.log(i);

        this.del_index=i;

      },
      leave(i) {

        // console.log(i);

        this.del_index=-1;
      },
      del_img(i){

        // console.log(i);
          
        let temp = this.cloneObj(this.list);
          
        this.messageCommon('提示','确定删除吗?','error').then(()=>{
          
          temp.splice(i,1);
          
          this.$emit('update:list', temp);

        })


      }


    },
    created() {



    },
    computed: {


    },
    components: {
      Upload
    },
    props: {

      /**
       * 上传组件的所有属性
       */
      UploadProperty: {
        type: Object,
        default: function() {

          return {};
        }
      },
      /**
       * 图片列表
       */
      list: {
        type: Array,
        default: function() {

          return [];
        }

      },



    }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/ImgList.vue